import { createContext, useContext } from 'react';
import type { ColorMode } from './tokens';

/**
 * Contexto e hook do modo claro/escuro.
 *
 * Vive fora de `AimThemeProvider.tsx` de propósito: um arquivo que exporta um
 * componente **e** um hook quebra o fast refresh do Vite
 * (`react-refresh/only-export-components`).
 */

export type ColorModePreference = ColorMode | 'system';

/** Chave do `localStorage` onde a preferência do usuário persiste. */
export const COLOR_MODE_STORAGE_KEY = 'aim.color-mode';

export interface ColorModeContextValue {
  /** O que o usuário escolheu (`system` = seguir o sistema operacional). */
  preference: ColorModePreference;
  /** O modo realmente aplicado. */
  mode: ColorMode;
  setPreference: (p: ColorModePreference) => void;
}

export const ColorModeContext = createContext<ColorModeContextValue>({
  preference: 'system',
  mode: 'light',
  setPreference: () => {},
});

export const useColorMode = (): ColorModeContextValue => useContext(ColorModeContext);
